import React from "react";
import { usePrinterExtraStore } from "../../state/storePrinterExtra";

type Props = {};

const RightPrinter = (props: Props) => {
  const {
    printer_right1,
    printer_right2,
    printer_right3,
    printer_right4,
    printer_right5,
    printer_right6,
    printer_right7,
  } = usePrinterExtraStore((state) => state);
  return (
    <div className="pl-[0]">
      <p>{printer_right1}</p>
      <p>{printer_right2}</p>
      <p>{printer_right3}</p>
      <p>{printer_right4}</p>
      <p>{printer_right5}</p>
      <p>{printer_right6}</p>
      <p>{printer_right7}</p>
    </div>
  );
};

export default RightPrinter;
